<template>
  <v-card class="mb-4">
    <!-- <v-progress-linear
      class="ma-auto"
      v-show="loading"
      :indeterminate="true"
    /> -->

    <v-toolbar dense>
      <v-toolbar-title>
        Forms
        <small v-if="wpUser.id">
          <em>
            <a :href="wpUser.adminLink" target="_blank">
              (WP ID:{{ wpUser.id }})
            </a>
          </em>
        </small>
      </v-toolbar-title>
      <v-spacer />

      <v-btn icon @click="loadForms">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div> -->

    <v-data-table
      dense
      :items="entries"
      :headers="tableHeaders"
      :loading="loading"
      :options.sync="options"
      :no-data-text="message || errors.join(' | ') || 'No data available'"
    >
      <template v-slot:item="props">
        <tr v-if="formTitle(props.item.form_id)">
          <td><a href=""></a>{{ props.item.id }}</td>
          <td>{{ props.item.date_created | formatDate }}</td>
          <td>{{ formTitle(props.item.form_id) }}</td>
          <td>
            {{ props.item.payment_amount }}
            <span v-if="props.item.payment_status"
              >({{ props.item.payment_status }})</span
            >
          </td>
          <td>
            <span v-if="props.item.workflow_final_status">
              {{ props.item.workflow_final_status }}
            </span>
          </td>
          <td>
            <v-dialog max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon>details</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar dense>
                  <v-toolbar-title card class="headline">
                    {{ formTitle(props.item.form_id) }}
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <table>
                    <template v-for="(value, fieldId) in props.item">
                      <tr :key="fieldId" v-if="value && fieldId != '_labels'">
                        <td>
                          <strong>
                            {{ getFieldLabel(props.item._labels, fieldId) }}
                          </strong>
                        </td>
                      </tr>
                      <tr :key="fieldId">
                        <td class="pb-2">
                          {{ value }}
                        </td>
                      </tr>
                    </template>
                  </table>

                  <!-- {{props.item}} -->
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-btn icon :href="props.item.entryLink" target="_blank">
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WPFormsList",
  data() {
    return {
      person: {},
      wpUser: {},
      entries: [],
      forms: {},
      errors: [],
      loading: false,
      options: {
        sortDesc: [true]
      },
      tableHeaders: [
        { text: "Entry ID", value: "id", width: "10em" },
        { text: "Created", value: "date_created" },
        { text: "Form", value: "form_id" },
        { text: "Payment Amount", value: "payment_amount", width: "12em" },
        {
          text: "Workflow Status",
          value: "workflow_final_status",
          width: "15em"
        },
        { text: "", value: "", sortable: false, width: "10em" }
      ],
      message: ""
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup" })
  },
  methods: {
    loadForms: async function() {
      if (!this.personId) {
        return;
      }
      this.loading = true;
      this.errors = [];
      try {
        var { data } = await this.$http.get(
          `/people/${this.personId}/formEntries`
        );

        if (data) {
          this.entries = [...data.entries];
          this.wpUser = { ...data.wpUser };

          data.forms.forEach(f => this.$set(this.forms, f.id, f));
        }

        this.loading = false;
        this.errors = [];
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    handleError(e) {
      this.errors.push(e.message);
    },
    getFieldLabel(labels, fieldId) {
      if (!labels[fieldId]) {
        return fieldId;
      } else {
        return labels[fieldId];
      }

      // for (let idx in form.fields) {
      //   let field = form.fields[idx];

      //   if (field["id"] != Math.floor(fieldId)) {
      //     continue;
      //   }
      //   return field["adminLabel"] || field["label"];
      // }
    },
    formTitle(formId) {
      return this.forms[formId]?.title;
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadForms",
      immediate: true
    }
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  }
};
</script>
